import * as React from 'react';
import { FooterLayout } from 'ui/components/Footer/FooterLayout';

export const CareerFooter: React.FC = () => {
  return (
    <FooterLayout className='career-footer'>
      {/* Career footer content goes here */}
    </FooterLayout>
  );
};
